import styled from 'styled-components'

export const Icon = styled.img.attrs<{ icon: string }>(props => ({
  src: props.icon,
}))<{ icon: string; size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`
